import { NgModule } from '@angular/core';
import { OvGenericModule } from '@ov-suite/ui';
import { EquipmentType } from '@ov-suite/models-admin';

@NgModule({
  imports: [
    OvGenericModule.forRoot({
      entity: EquipmentType,
      api: 'adminlink',
      createTitle: 'Equipment Type',
      route: ['equipment-type'],
      tableTitle: 'Equipment Type',
      tabs: [
        {
          path: '/equipment',
          title: 'Equipment',
        },
        {
          path: '/equipment-type',
          title: 'Equipment Type',
        },
      ],
      permissionId: 906,
    }),
  ],
})
export class EquipmentTypeModule {}
